// import React from 'react'
// import { TbMinus, TbPlus } from 'react-icons/tb'
// import { AiFillDelete } from 'react-icons/ai'
// import { useDispatch } from 'react-redux'
// import { decreaseQty, deleteCartItem, increaseQty } from '../redux/productSlice'
// const CartProduct = ({ id, name, image, category, qty, total, price }) => {

//   const dispatch = useDispatch()

//   return (
//     <div className='bg-slate-200 p-2 flex gap-4 rounded border border-slate-300'>
//       <div className='p-3 bg-white rounded overflow-hidden'>
//         <img src={image} className="h-28 w-40 object-cover" alt="productImage" />
//       </div>
//       <div className='flex flex-col gap-1 w-full'>
//         <div className='flex justify-between'>
//           <h3 className='font-semibold text-slate-600 capitalize text-lg md:text-xl'>
//             {name}
//           </h3>
//           <div className='cursor-pointer text-slate-700 hover:text-red-500' onClick={() => dispatch(deleteCartItem(id))}>
//             <AiFillDelete />
//           </div>
//         </div>

//         <p className='text-slate-500 font-medium'>{category}</p>
//         <p className='font-bold text-base'>
//           <span className='text-red-500'>₹</span>
//           <span>{price}</span>
//         </p>
//         <div className='flex justify-between'>
//           <div className='flex gap-3 items-center'>
//             <button className='bg-slate-300 py-1 mt-2 rounded hover:bg-slate-400 p-1' onClick={()=>dispatch(increaseQty(id))}><TbPlus /></button>
//             <p className='font-semibold p-1'>{qty}</p>
//             <button className='bg-slate-300 py-1 mt-2 rounded hover:bg-slate-400 p-1'  onClick={()=>dispatch(decreaseQty(id))}><TbMinus /></button>
//           </div>
//           <div className='flex item-center gap-2 font-bold text-slate-700'>
//             <p>Total : </p>
//             <p><span className='text-red-500'>₹</span>{total}</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CartProduct;


import React from 'react';
import { useDispatch } from 'react-redux';
import { decreaseQty, deleteCartItem, increaseQty } from '../redux/productSlice';
import { TbMinus, TbPlus } from 'react-icons/tb';
import { RiDeleteBin6Line } from 'react-icons/ri';

export default function CartProduct({ id, name, image, category, qty, total, price }) {
  const dispatch = useDispatch();

  const safeTotal = typeof total === 'number' ? total.toFixed(2) : total;

  return (
    <div className="cart-row p-4 flex gap-4 animate-fade-up">

      {/* Image */}
      <div
        className="w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden flex items-center justify-center"
        style={{ background: 'var(--bg-surface)', border: '1px solid var(--glass-border)' }}
      >
        <img
          src={image}
          alt={name}
          className="w-full h-full object-contain p-2 hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Details */}
      <div className="flex flex-col flex-1 min-w-0 gap-1.5">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <span className="badge inline-block mb-1" style={{ fontSize: '0.58rem' }}>{category}</span>
            <h3
              className="text-sm md:text-base font-semibold capitalize leading-tight truncate"
              style={{ color: 'var(--text-primary)' }}
            >
              {name}
            </h3>
          </div>
          {/* Delete */}
          <button
            onClick={() => dispatch(deleteCartItem(id))}
            className="flex-shrink-0 p-1.5 rounded-lg transition-all duration-200
                       hover:bg-[var(--coral-dim)] hover:text-[var(--coral)]"
            style={{ color: 'var(--text-muted)' }}
            aria-label="Remove item"
          >
            <RiDeleteBin6Line className="text-base" />
          </button>
        </div>

        <p className="font-display text-sm font-bold">
          <span style={{ color: 'var(--coral)' }}>₹</span>
          <span style={{ color: 'var(--text-secondary)' }}>{price}</span>
          <span className="font-body font-normal text-xs ml-1" style={{ color: 'var(--text-muted)' }}>
            per unit
          </span>
        </p>

        {/* Controls row */}
        <div className="flex items-center justify-between mt-auto">
          {/* Qty */}
          <div className="flex items-center gap-2">
            <button className="qty-btn" onClick={() => dispatch(decreaseQty(id))}>
              <TbMinus />
            </button>
            <span
              className="w-7 text-center text-sm font-semibold"
              style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-mono)' }}
            >
              {qty}
            </span>
            <button className="qty-btn" onClick={() => dispatch(increaseQty(id))}>
              <TbPlus />
            </button>
          </div>

          {/* Line total */}
          <div className="text-right">
            <p className="text-xs font-mono mb-0.5" style={{ color: 'var(--text-muted)' }}>Total</p>
            <p className="font-display text-base font-bold text-gradient">₹{safeTotal}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
